module.exports = __webpack_public_path__ + "img/105.845f20e9.gif";